<div class="content-wrapper">
  <div class="widget-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>